export default "__VITE_ASSET__BgqvGIeE__"